import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_bilan",
  tabindex: "-1",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "message message-expired" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Bilan impossible")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "Toutes les séances de bilan ont été utilisées. Veuillez renouveler pour pouvoir effectuer un nouveau bilan")
  ])
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-md-6 mb-2" }
const _hoisted_14 = { class: "col-md-6 mb-2" }
const _hoisted_15 = { class: "row mb-4" }
const _hoisted_16 = {
  key: 0,
  class: "col-md-12 mb-3"
}
const _hoisted_17 = { class: "form-group mr-b-0em" }
const _hoisted_18 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-12 text-right mt-3" }
const _hoisted_31 = {
  type: "submit",
  class: "btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_informations_income = _resolveComponent("informations-income")!
  const _component_radioInput = _resolveComponent("radioInput")!
  const _component_input_image = _resolveComponent("input-image")!
  const _component_capture_photo = _resolveComponent("capture-photo")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_inputTextarea = _resolveComponent("inputTextarea")!
  const _component_inputText = _resolveComponent("inputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestBilan)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.action === 'add'
                            ? _ctx.i18n.t('views.clients.bilans.add')
                            : _ctx.i18n.t('views.clients.bilans.edit')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_add_bilan', 'add')))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_informations_income),
          (_ctx.income && _ctx.income?.remaining_sessions === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
                class: "forms-sample"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_radioInput, {
                        modelValue: _ctx.isCaputre,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCaputre) = $event)),
                        valueAttr: 1,
                        label: _ctx.i18n.t('button.upload_image'),
                        name: `isCaputre`,
                        id: "club-logo-1"
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_radioInput, {
                        modelValue: _ctx.isCaputre,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isCaputre) = $event)),
                        valueAttr: 0,
                        label: _ctx.i18n.t('button.take_photo'),
                        name: `isCaputre`,
                        id: "club-logo-0"
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.isCaputre)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_input_image, {
                              modelValue: _ctx.requestBilan.path_image,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestBilan.path_image) = $event)),
                              label: _ctx.i18n.t('tables.club.path_image'),
                              pathImage: _ctx.image,
                              v: _ctx.v$.path_image,
                              disabled: false
                            }, null, 8, ["modelValue", "label", "pathImage", "v"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isCaputre)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_capture_photo, {
                            modelValue: _ctx.requestBilan.path_image,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestBilan.path_image) = $event)),
                            v: _ctx.v$.path_image,
                            pathImage: _ctx.image
                          }, null, 8, ["modelValue", "v", "pathImage"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_SingleSelect, {
                      TextLabel: _ctx.i18n.t('tables.session.trainer'),
                      trackby: `id`,
                      label: `name`,
                      valueProp: `id`,
                      modelValue: _ctx.requestBilan.trainer_id,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestBilan.trainer_id) = $event)),
                      placeholder: _ctx.i18n.t('tables.session.trainer'),
                      arrayOptions: _ctx.trainersList,
                      refs: "trainers",
                      v: _ctx.v$.trainer_id
                    }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_date_field, {
                      modelValue: _ctx.requestBilan.bilan_date,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestBilan.bilan_date) = $event)),
                      label: _ctx.i18n.t('tables.bilans.bilan_date'),
                      v: _ctx.v$.bilan_date,
                      disabled: false,
                      fixedDays: 0,
                      isFixedDays: false
                    }, null, 8, ["modelValue", "label", "v"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_inputTextarea, {
                      modelValue: _ctx.requestBilan.notes,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestBilan.notes) = $event)),
                      label: _ctx.i18n.t('tables.bilans.notes'),
                      v: _ctx.v$.notes
                    }, null, 8, ["modelValue", "label", "v"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_inputText, {
                      modelValue: _ctx.requestBilan.measurements.weight,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestBilan.measurements.weight) = $event)),
                      label: _ctx.i18n.t('tables.bilans.measurements.weight'),
                      disabled: false
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_inputText, {
                      modelValue: _ctx.requestBilan.measurements.height,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestBilan.measurements.height) = $event)),
                      label: _ctx.i18n.t('tables.bilans.measurements.height'),
                      disabled: false
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_inputText, {
                      modelValue: _ctx.requestBilan.measurements.fat_percentage,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestBilan.measurements.fat_percentage) = $event)),
                      label: _ctx.i18n.t('tables.bilans.measurements.fat_percentage'),
                      disabled: false
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_inputText, {
                      modelValue: _ctx.requestBilan.measurements.muscle_mass,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestBilan.measurements.muscle_mass) = $event)),
                      label: _ctx.i18n.t('tables.bilans.measurements.muscle_mass'),
                      disabled: false
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_inputText, {
                      modelValue: _ctx.requestBilan.measurements.chest,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.requestBilan.measurements.chest) = $event)),
                      label: _ctx.i18n.t('tables.bilans.measurements.chest'),
                      disabled: false
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_inputText, {
                      modelValue: _ctx.requestBilan.measurements.waist,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requestBilan.measurements.waist) = $event)),
                      label: _ctx.i18n.t('tables.bilans.measurements.waist'),
                      disabled: false
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_inputText, {
                      modelValue: _ctx.requestBilan.measurements.arms,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requestBilan.measurements.arms) = $event)),
                      label: _ctx.i18n.t('tables.bilans.measurements.arms'),
                      disabled: false
                    }, null, 8, ["modelValue", "label"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("button", _hoisted_31, _toDisplayString(_ctx.action === 'add'
                                        ? _ctx.i18n.t('button.add')
                                        : _ctx.i18n.t('button.edit')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-cancel",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.emptyState && _ctx.emptyState(...args)))
                    }, _toDisplayString(_ctx.i18n.t('button.clean')), 1)
                  ])
                ])
              ], 32))
        ])
      ])
    ])
  ]))
}